var getters = {
  userName: function userName(state) {
    return state.app.userName;
  },
  valuationData: function valuationData(state) {
    return state.valuationData;
  }
};
export default getters;